import React from 'react';
import { CheckIcon, XIcon } from '@heroicons/react/outline';

// Shows every password rule from getPasswordRules with a tick or cross, updating as the user types.
const PasswordChecklist = ({ rules }) => (
  <ul className="w-full mt-1 space-y-1 text-sm text-left" aria-live="polite">
    {rules.map(({ label, met }) => (
      <li key={label} className={`flex items-start ${met ? 'text-green-600' : 'text-red-500'}`}>
        {met
          ? <CheckIcon className="flex-shrink-0 w-4 h-4 mt-0.5 mr-2" aria-hidden="true" />
          : <XIcon className="flex-shrink-0 w-4 h-4 mt-0.5 mr-2" aria-hidden="true" />}
        <span>
          {label}
          <span className="sr-only">{met ? ' (met)' : ' (not met)'}</span>
        </span>
      </li>
    ))}
  </ul>
);

export default PasswordChecklist;
